// extracted by mini-css-extract-plugin
module.exports = {"container":"LoaderSmall_container___qBDg","grid":"LoaderSmall_grid__2UgMY","point":"LoaderSmall_point__xVuSP","appear":"LoaderSmall_appear__dM4pT"};